import { useTranslate } from 'react-polyglot';

import { PodiumIcon } from '@genially/icons';

import { useHostGameContext } from '../../../../HostGame.context';
import { SidebarLink } from '../SidebarLink/SidebarLink';

export const RankingSidebarLink = () => {
  const t = useTranslate();
  const { settingsSidebar, sidebarSummary } = useHostGameContext();

  const handleClick = () => {
    settingsSidebar.close();

    sidebarSummary.removeSelectedQuestion();
    sidebarSummary.open();
  };

  return (
    <SidebarLink
      Icon={PodiumIcon}
      text={t('__new.play.shared.viewRanking')}
      onClick={handleClick}
    ></SidebarLink>
  );
};
